import React from 'react';
import styled from 'styled-components';

import Typography from 'antd/es/typography';

const { Text } = Typography;

const InfoLabelWrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.inline ? 'row' : 'column'};
  align-items: ${props => props.inline ? 'center' : 'flex-start'};
  justify-content: ${props => props.inline ? 'flex-start' : 'center'};

  & .name {
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #A4B0BA;
  }

  & .value {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: #45494D;
  }
`;

const InfoLabel = ({ name, value, inline, extra = null, ...rest }) => (
  <InfoLabelWrapper inline={inline}>
    <Text className="name">{name}:</Text>&nbsp;
    {
      value ? <Text className="value" {...rest}>{value}</Text>
      : <Text className="value">-</Text>
    }
    {extra}
  </InfoLabelWrapper>
);

export default InfoLabel;
